import type { GraphRow } from "./git-graph";

export const ROW_H = 56;
const LANE_W = 16;
const COLORS = ["#4aa3ff", "#e5a23c", "#5cc47a", "#d46ad9", "#e86a6a", "#3cc4c4"];
const colorOf = (lane: number) => COLORS[lane % COLORS.length]!;

/** One row of the graph: the lines into and out of this commit's dot, in the colour of each lane. */
export function GraphCell({ row, lanes }: { row: GraphRow; lanes: number }) {
  const x = (l: number) => l * LANE_W + LANE_W / 2;
  const mid = ROW_H / 2;
  return (
    <svg className="git-graph-cell" width={lanes * LANE_W} height={ROW_H} aria-hidden>
      {row.top.map((t, i) => (
        <path key={"t" + i} d={t.lane === t.to ? `M${x(t.lane)} 0V${t.to === row.lane ? mid : ROW_H}` : `M${x(t.lane)} 0C${x(t.lane)} ${mid / 2} ${x(t.to)} ${mid / 2} ${x(t.to)} ${mid}`} stroke={colorOf(t.lane)} strokeWidth="2" fill="none" />
      ))}
      {row.bottom.map((b, i) => (
        <path key={"b" + i} d={b.lane === b.from ? `M${x(b.lane)} ${b.from === row.lane ? mid : 0}V${ROW_H}` : `M${x(b.from)} ${mid}C${x(b.from)} ${mid * 1.5} ${x(b.lane)} ${mid * 1.5} ${x(b.lane)} ${ROW_H}`} stroke={colorOf(b.lane === b.from ? b.lane : b.lane)} strokeWidth="2" fill="none" />
      ))}
      <circle cx={x(row.lane)} cy={mid} r="5" fill={colorOf(row.lane)} stroke="var(--bg, #000)" strokeWidth="2" />
    </svg>
  );
}

